import { Injectable } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  showSpinner = false;

  private spinnerTracker = 0;

  constructor(
    private spinner: NgxSpinnerService
  ) { }

    show(){this.spinner.show();}
    hide(){this.spinner.hide();}


  open() {
    this.spinnerTracker++;
    setTimeout(() => {
      this.showSpinner = true
    });
  }

  close() {
    if (this.spinnerTracker > 0) {
      this.spinnerTracker--;
    }
    if (this.spinnerTracker === 0) {
      setTimeout(() => {
        this.showSpinner = false
      });
    }
  }

  reset() {
    this.spinnerTracker = 0;
    this.showSpinner = false;
  }
}
